import { useCallback, useEffect, useRef, useState } from 'react';
import { FULLSCREEN_FILE_VIEWER_MAX_ZOOM, FULLSCREEN_FILE_VIEWER_MIN_ZOOM, } from 'src/ui/views/dynamics/CaseGlobalViewPage/components/FullScreenFilesViewer/constants';
import { VIDEO_ZOOM_INITIAL_POSITION as INITIAL_POSITION, VIDEO_ZOOM_STEP } from 'src/ui/components/VideoPlayer/constants';
import { getClampedZoomPosition } from './helpers';
export var useVideoZoom = function (viewportRef, resetDependency) {
    var _a = useState(FULLSCREEN_FILE_VIEWER_MIN_ZOOM), scale = _a[0], setScale = _a[1];
    var _b = useState(INITIAL_POSITION), position = _b[0], setPosition = _b[1];
    var _c = useState(false), isDragging = _c[0], setIsDragging = _c[1];
    var lastPointerRef = useRef(null);
    var isZoomed = scale > FULLSCREEN_FILE_VIEWER_MIN_ZOOM;
    var isZoomInDisabled = scale >= FULLSCREEN_FILE_VIEWER_MAX_ZOOM;
    var isZoomOutDisabled = !isZoomed;
    var handleReset = useCallback(function () {
        lastPointerRef.current = null;
        setScale(FULLSCREEN_FILE_VIEWER_MIN_ZOOM);
        setPosition(INITIAL_POSITION);
        setIsDragging(false);
    }, []);
    useEffect(function () {
        handleReset();
    }, [resetDependency, handleReset]);
    var getViewportSize = function () {
        var _a, _b;
        var width = ((_a = viewportRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0;
        var height = ((_b = viewportRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight) || 0;
        return { width: width, height: height };
    };
    var handleZoomIn = function () {
        var newScale = Math.min(scale + VIDEO_ZOOM_STEP, FULLSCREEN_FILE_VIEWER_MAX_ZOOM);
        setScale(newScale);
    };
    var handleZoomOut = function () {
        var newScale = Math.max(scale - VIDEO_ZOOM_STEP, FULLSCREEN_FILE_VIEWER_MIN_ZOOM);
        var newPosition = newScale === FULLSCREEN_FILE_VIEWER_MIN_ZOOM
            ? INITIAL_POSITION
            : getClampedZoomPosition(position, newScale, getViewportSize());
        setScale(newScale);
        setPosition(newPosition);
    };
    var handleMouseDown = function (e) {
        e.preventDefault();
        var isLeftButton = e.button === 0;
        if (isZoomed && isLeftButton) {
            lastPointerRef.current = { x: e.clientX, y: e.clientY };
            setIsDragging(true);
        }
    };
    var handleMouseMove = function (e) {
        var lastPointer = lastPointerRef.current;
        if (!lastPointer) {
            return;
        }
        var newPosition = {
            x: position.x + (e.clientX - lastPointer.x) / scale,
            y: position.y + (e.clientY - lastPointer.y) / scale,
        };
        lastPointerRef.current = { x: e.clientX, y: e.clientY };
        setPosition(getClampedZoomPosition(newPosition, scale, getViewportSize()));
    };
    var handleMouseUp = function () {
        lastPointerRef.current = null;
        setIsDragging(false);
    };
    return {
        scale: scale,
        position: position,
        isDragging: isDragging,
        isZoomInDisabled: isZoomInDisabled,
        isZoomOutDisabled: isZoomOutDisabled,
        onZoomIn: handleZoomIn,
        onZoomOut: handleZoomOut,
        onReset: handleReset,
        onMouseDown: handleMouseDown,
        onMouseMove: handleMouseMove,
        onMouseUp: handleMouseUp,
    };
};
